<template>
  <b-container>
    <!--title-->
    <h1 class="title">
      <strong>دسته بندی محصولات</strong>
    </h1>
    <!--category-->
    <div class="category parentLoading">
      <Loading :class="{loading1:true?loading1:false}" />
      <div v-for="(category,index) in categories2.children" class="catItem" :key="index">
        <app-tree :tree-data="category"></app-tree>
      </div>
    </div>
  </b-container>
</template>
<script>
import axios from "axios";
import Tree from "./Tree";
import Loading from "../../Loading";
export default {
  data() {
    return {
      categories: [],
      categories2: null,
      loading1: false,
    };
  },
  components: {
    appTree: Tree,
    Loading,
  },
  async created() {
    try {
      if (this.categories2 == null) {
        this.loading1 = true;
      }
      await axios
        .get("/product/GetProductCategories")
        .then((res) => {
          this.categories = res.data;
          this.categories2 = setChildren(this.categories, 95);
          this.loading1 = false;
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (e) {
      console.log(e);
    }
  },
};
function setChildren(allCategory, parentId) {
  var child = {
    parentId: parentId,
    Name: "",
    children: [],
  };
  var childs = [];
  allCategory.forEach((element) => {
    if (element.ProductsCategoriesId == parentId) {
      childs.push(element);
    }
    if (element.Id == parentId) {
      child.Name = element.Name;
    }
  });
  childs.forEach((element) => {
    child.children.push(setChildren(allCategory, element.Id));
  });
  return child;
}
</script>

<style scoped>
.loading1 {
  display: block;
}
.categoryList {
  margin-bottom: 15px;
  width: 100%;
}
.title {
  margin-bottom: 35px;
}
.catItem {
  text-align: right;
}
.catItem ul {
  padding: 0;
}
@media all and (max-width: 576px) {
  .catItem ul {
    margin-bottom: 5px;
  }
  .title {
    margin-bottom: 15px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/products/category/Category.vue